import { useContext } from "react";
import { TextsContext } from "../context/textsContext";
import { useCountries } from "../api/quoterApi";
import { useCotizador } from "../context/apiContext";
import { getAge } from "../helpers/toolsHelper";
import { useFeeTable } from "./FeeTableHook";
import { useSteps } from "./useSteps";
import { getStructuralBenefits, transformData } from "components/utils/RequestQuoter.util";

export const usePdf = () => {
  const { getCurrentLanguage, texts } = useContext(TextsContext);
  const { contextState, isFemale } = useCotizador();
  const { getValuesPdf } = useFeeTable();
  const { getCountryName } = useCountries();
  const { getBenefitsPerStep } = useSteps()

  const getGenderName = (value) => {
    // eslint-disable-next-line eqeqeq
    return value == 1 ? texts?.general_form_option_male ?? "MALE" : texts?.general_form_option_female ?? "FEMALE";
  }

  const getSpouse = () => {
    return contextState.dependants.find(
      // eslint-disable-next-line eqeqeq
      (dependant) => dependant.componentId == "15"
    );
  };

  const getDependants = () => {
    return contextState.dependants.map((dependant) => ({
        ...dependant,
        age: getAge(dependant.birthday, contextState.coverage),
        countryName: getCountryName(dependant.country, getCurrentLanguage()),
        genderName: getGenderName(dependant.gender)
    }))
  }

  const getSpouseInfo = () => {
    return getSpouse()
      ? {
        ...getSpouse(),
        age: getAge(getSpouse().birthday, contextState.coverage),
        countryName: getCountryName(getSpouse().country, getCurrentLanguage()),
        genderName: getGenderName(getSpouse().gender)
      }
      : {}
  }

  const todayDate = new Date();
  const today = `${todayDate.getUTCFullYear()}-${todayDate.getMonth() + 1
    }-${todayDate.getUTCDate()}`;

  const getPdfData = () => ({
    locale: getCurrentLanguage(),
    ...contextState,
    outpationBenefitsmaternidad: (contextState?.outpationBenefitsmaternidad && isFemale()),
    dependants: getDependants(),
    list: getValuesPdf(),
    today,
    selectedBenefitsNames: Object.entries(contextState.selectedBenefitsNames).reduce((arr, [key, value]) => {
      arr[key] = getBenefitsPerStep().includes(key) ? value : ("None");
      return arr;
    }, {}),
    selectedBenefitsIds: Object.entries(contextState.selectedBenefitsIds).reduce((arr, [key, value]) => {
      arr[key] = getBenefitsPerStep().includes(key) ? value : (0);
      return arr;
    }, {}),
    countryName: getCountryName(contextState.country, getCurrentLanguage()),
    // eslint-disable-next-line eqeqeq
    genderName: getGenderName(contextState.gender),
    applicantAge: getAge(contextState.birthday, contextState.coverage),
    planName: "MY VIP CARE 1",
    spouseData: getSpouseInfo()
  });

  const getPdfRefactorData = () => {

    const { 
      benefits, 
      riders,
    } = transformData(contextState);

    const structuralBenefits = getStructuralBenefits(contextState);

    return {
      locale: getCurrentLanguage(),
      coverage: contextState.coverage,
      name: contextState.name,
      surname: contextState.surname,
      timely: contextState.timely,
      countryName: getCountryName(contextState.country, getCurrentLanguage()),
      today,
      coverageShow: contextState.coverageShow,
      applicantAge: getAge(contextState.birthday, contextState.coverage),
      genderName: getGenderName(contextState.gender),
      spouseData: getSpouseInfo(),
      dependants: getDependants(),
      addDependant: contextState.addDependant,
      list: getValuesPdf(),
      benefits,
      riders,
      structuralBenefits,
      isCountryResidenceDeductible: Boolean(contextState.isCountryResidenceDeductible)
    };
  };

  return {
    getPdfData,
    getPdfRefactorData
  };
};
